export const PRODUCTS = [
  {
    id: "pr-1",
    name: "Faccy T shirt",
    description: "Immerse yourself in premium sound quality with our Wireless Noise-Canceling Headphones. Enjoy crystal-clear audio, comfortable design, and the freedom of wireless connectivity for an unparalleled listening experience.",
    price: 3000,
    image: "/BOSHOP images/item-img-1-1.jpg",
    rating: 5,
    review: [
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "8",
      },
    ],
    //   absolute path "/images/box7_image.jpg"
    // when i was adding "./images/box7_image.jpg" it was not showing on other page
    multipleimages: [
      "/BOSHOP images/item-img-1-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-1-1.jpg",
    ],
  },
  {
    id: "pr-2",
    name: "Beats Headphone",
    rating: 4,
    review: [
      {
        text: "Stylish Smart Thermostat – makes home climate control a breeze!",
        rating: "8",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "10",
      },
    ],
    description: "Stay fit and connected with our Smart Fitness Tracker. Monitor your daily activities, heart rate, and sleep patterns. The sleek design and intuitive app make it easy to achieve your fitness goals",
    price: 999,
    image: "/BOSHOP images/item-img-1-2-1.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-2.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-2-1.jpg",
    ],
  },
  {
    id: "pr-3",
    name: "Beats Headphone",
    rating: 3,
    review: [
      {
        text: "Top-notch Camera Drone – capturing stunning aerial shots effortlessly.",
        rating: "2",
      },
      {
        text: "Stylish Smart Thermostat – makes home climate control a breeze!",
        rating: "4",
      },
    ],
    description: "Start your day with the perfect cup of espresso using our Compact Espresso Maker. This space-saving appliance combines style and functionality, allowing you to enjoy rich and flavorful coffee in the comfort of your home.",
    price: 899,
    image: "/BOSHOP images/item-img-1-3.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-3-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-3.jpg",
    ],
  },
  {
    id: "pr-4",
    name: "Beats Headphone",
    rating: 2,
    review: [
      {
        text: "Top-notch Camera Drone – capturing stunning aerial shots effortlessly.",
        rating: "6",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "7",
      },
    ],
    description: "Start your day with the perfect cup of espresso using our Compact Espresso Maker. This space-saving appliance combines style and functionality, allowing you to enjoy rich and flavorful coffee in the comfort of your home.",
    price: 799,
    image: "/BOSHOP images/item-img-1-4.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-4-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-4.jpg",
    ],
  },
  {
    id: "pr-5",
    name: "Beats Headphone",
    rating: 2,
    review: [
      {
        text: "Top-notch Camera Drone – capturing stunning aerial shots effortlessly.",
        rating: "6",
      },
      {
        text: "Top-notch Camera Drone – capturing stunning aerial shots effortlessly.",
        rating: "3",
      },
    ],
    description: "Immerse yourself in premium sound quality with our Wireless Noise-Canceling Headphones. Enjoy crystal-clear audio, comfortable design, and the freedom of wireless connectivity for an unparalleled listening experience.",
    price: 599,
    image: "/BOSHOP images/item-img-1-5.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  {
    id: "pr-6",
    name: "Beats Headphone",
    rating: 2,
    review: [
      {
        text: "Top-notch Camera Drone – capturing stunning aerial shots effortlessly.",
        rating: "5",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "5",
      },
    ],
    description: "Start your day with the perfect cup of espresso using our Compact Espresso Maker. This space-saving appliance combines style and functionality, allowing you to enjoy rich and flavorful coffee in the comfort of your home.",
    price: 399,
    image: "/BOSHOP images/item-img-1-6.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-6-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-6.jpg",
    ],
  },
  {
    id: "pr-7",
    name: "Beats Headphone",
    rating: 2,
    review: [
      {
        text: "Top-notch Camera Drone – capturing stunning aerial shots effortlessly.",
        rating: "6",
      },
      {
        text: "Stylish Smart Thermostat – makes home climate control a breeze!",
        rating: "9",
      },
    ],
    description: "Start your day with the perfect cup of espresso using our Compact Espresso Maker. This space-saving appliance combines style and functionality, allowing you to enjoy rich and flavorful coffee in the comfort of your home.",
    price: 8899,
    image: "/BOSHOP images/item-img-1-7.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-7-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-7.jpg",
    ],
  },
  {
    id: "pr-8",
    name: "Beats Headphone",
    rating: 2,
    review: [
      {
        text: "Top-notch Camera Drone – capturing stunning aerial shots effortlessly.",
        rating: "9",
      },
      {
        text: "The Wireless Noise-Canceling Headphones deliver premium sound quality.",
        rating: "2",
      },
    ],
    description: "Elevate your gaming experience with our High-Speed Gaming Mouse. Precision tracking, customizable buttons, and ergonomic design provide the competitive edge you need. Dominate the virtual battlefield with style and performance.",
    price: 44999,
    image: "/BOSHOP images/item-img-1-8.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-8-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-8.jpg",
    ],
  },
  {
    id: "pr-9",
    name: "Beats Headphone",
    rating: 2,
    review: [
      {
        text: "The Wireless Noise-Canceling Headphones deliver premium sound quality.",
        rating: "3",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "4",
      },
    ],
    description: "Start your day with the perfect cup of espresso using our Compact Espresso Maker. This space-saving appliance combines style and functionality, allowing you to enjoy rich and flavorful coffee in the comfort of your home.",
    price: 33999,
    image: "/BOSHOP images/item-img-1-9.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-9-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-9.jpg",
    ],
  },
  {
    id: "pr-10",
    name: "Beats Headphone",
    rating: 4,
    review: [
      {
        text: "Compact Espresso Maker – my morning ritual just got better!",
        rating: "6",
      },
      {
        text: "Stylish Smart Thermostat – makes home climate control a breeze!",
        rating: "5",
      },
    ],
    description: "Immerse yourself in premium sound quality with our Wireless Noise-Canceling Headphones. Enjoy crystal-clear audio, comfortable design, and the freedom of wireless connectivity for an unparalleled listening experience.",
    price: 1999,
    image: "/BOSHOP images/item-img-1-10.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-10-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-10.jpg",
    ],
  },
  {
    id: "pr-11",
    name: "Beats Headphone",
    rating: 8,
    review: [
      {
        text: "Robotic Vacuum Cleaner – a lifesaver for keeping my home spotless",
        rating: "6",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "5",
      },
    ],
    description: "Elevate your gaming experience with our High-Speed Gaming Mouse. Precision tracking, customizable buttons, and ergonomic design provide the competitive edge you need. Dominate the virtual battlefield with style and performance.",
    price: 1999,
    image: "/BOSHOP images/item-img-1-3.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-3-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-3.jpg",
    ],
  },
  {
    id: "pr-12",
    name: "Beats Headphone",
    rating: 9,
    review: [
      {
        text: "Stylish Smart Thermostat – makes home climate control a breeze!",
        rating: "6",
      },
      {
        text: "Compact Espresso Maker – my morning ritual just got better!",
        rating: "5",
      },
    ],
    description: "Stay fit and connected with our Smart Fitness Tracker. Monitor your daily activities, heart rate, and sleep patterns. The sleek design and intuitive app make it easy to achieve your fitness goals",
    price: 1999,
    rating: 10,
    review: [
      {
        text: "The Wireless Noise-Canceling Headphones deliver premium sound quality.",
        rating: "7",
      },
      {
        text: "The Wireless Noise-Canceling Headphones deliver premium sound quality.",
        rating: "3",
      },
    ],
  
    image: "/BOSHOP images/item-img-1-5.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
];

export const bestSelling = [
  {
    id: "bs-1",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "Stylish Smart Thermostat – makes home climate control a breeze!",
        rating: "9",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "10",
      },
    ],
    description: "Elevate your gaming experience with our High-Speed Gaming Mouse. Precision tracking, customizable buttons, and ergonomic design provide the competitive edge you need. Dominate the virtual battlefield with style and performance.",
    price: 1299,
    image: "/BOSHOP images/item-img-1-5-1.jpg",
    multipleimages: [
      "/BOSHOP images/headphone.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/history-img.jpg",
    ],
  },
  {
    id: "bs-2",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "9",
      },
      {
        text: "The Wireless Noise-Canceling Headphones deliver premium sound quality.",
        rating: "10",
      },
    ],
    description: "Immerse yourself in premium sound quality with our Wireless Noise-Canceling Headphones. Enjoy crystal-clear audio, comfortable design, and the freedom of wireless connectivity for an unparalleled listening experience.",
    price: 1299,
    image: "/BOSHOP images/item-img-1-3.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-7.jpg",
      "/images/box4_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  
  {
    id: "bs-3",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "Compact Espresso Maker – my morning ritual just got better!",
        rating: "9",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "10",
      },
    ],
    description: "Immerse yourself in premium sound quality with our Wireless Noise-Canceling Headphones. Enjoy crystal-clear audio, comfortable design, and the freedom of wireless connectivity for an unparalleled listening experience.",
    price: 1299,
    image: "/BOSHOP images/item-img-1-10.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  {
    id: "bs-4",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "Robotic Vacuum Cleaner – a lifesaver for keeping my home spotless",
        rating: "9",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "10",
      },
    ],
    description: "Stay fit and connected with our Smart Fitness Tracker. Monitor your daily activities, heart rate, and sleep patterns. The sleek design and intuitive app make it easy to achieve your fitness goals",
    price: 1299,
    image: "/BOSHOP images/item-img-1-7.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  {
    id: "bs-5",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "9",
      },
      {
        text: "Robotic Vacuum Cleaner – a lifesaver for keeping my home spotless",
        rating: "10",
      },
    ],
    description: "Elevate your gaming experience with our High-Speed Gaming Mouse. Precision tracking, customizable buttons, and ergonomic design provide the competitive edge you need. Dominate the virtual battlefield with style and performance.",
    price: 1299,
    image: "/BOSHOP images/item-img-1-5-1.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  {
    id: "bs-6",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "The Wireless Noise-Canceling Headphones deliver premium sound quality.",
        rating: "9",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "10",
      },
    ],
    description: "Stay fit and connected with our Smart Fitness Tracker. Monitor your daily activities, heart rate, and sleep patterns. The sleek design and intuitive app make it easy to achieve your fitness goals",
    price: 1299,
    image: "/BOSHOP images/item-img-1-5-1.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  {
    id: "bs-7",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "Compact Espresso Maker – my morning ritual just got better!",
        rating: "9",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "10",
      },
    ],
    description: "Immerse yourself in premium sound quality with our Wireless Noise-Canceling Headphones. Enjoy crystal-clear audio, comfortable design, and the freedom of wireless connectivity for an unparalleled listening experience.",
    price: 1299,
    image: "/BOSHOP images/item-img-1-9-1.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  {
    id: "bs-8",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "Compact Espresso Maker – my morning ritual just got better!",
        rating: "9",
      },
      {
        text: "The Wireless Noise-Canceling Headphones deliver premium sound quality.",
        rating: "10",
      },
    ],
    description: "Start your day with the perfect cup of espresso using our Compact Espresso Maker. This space-saving appliance combines style and functionality, allowing you to enjoy rich and flavorful coffee in the comfort of your home.",
    price: 1299,
    image: "/BOSHOP images/item-img-1-5-1.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  {
    id: "bs-9",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "I absolutely love my Smart Fitness Tracker! It's like having a personal fitness coach on my wrist. The sleek design makes it easy to wear all day, and the app is user-friendly. It keeps me motivated to reach my fitness goals. Highly recommend for anyone looking to stay active and healthy!",
        rating: "9",
      },
      {
        text: "These headphones are a game-changer! The noise-canceling feature is incredible — it's like stepping into a quiet oasis, even in a busy environment. The sound quality is top-notch, and the wireless connectivity is seamless. Comfortable to wear for long periods. Definitely worth the investment for music lovers!",
        rating: "10",
      },
    ],
    description: "Elevate your gaming experience with our High-Speed Gaming Mouse. Precision tracking, customizable buttons, and ergonomic design provide the competitive edge you need. Dominate the virtual battlefield with style and performance.",
    price: 1299,
    image: "/BOSHOP images/item-img-1-5-1.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  {
    id: "bs-10",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "Robotic Vacuum Cleaner – a lifesaver for keeping my home spotless",
        rating: "9",
      },
      {
        text: "This Smart Fitness Tracker is a game-changer for my workouts!",
        rating: "10",
      },
    ],
    description: "Bring the party wherever you go with our Portable Bluetooth Speaker. Enjoy powerful, crisp sound in a compact and stylish design. The long-lasting battery and wireless connectivity make it the perfect companion for outdoor adventures and gatherings.",
    price: 1299,
    image: "/BOSHOP images/item-img-1-1.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
  {
    id: "bs-11",
    name: "Best Selling Headphone",
    rating: 5,
    review: [
      {
        text: "Compact Espresso Maker – my morning ritual just got better!",
        rating: "9",
      },
      {
        text: "Robotic Vacuum Cleaner – a lifesaver for keeping my home spotless",
        rating: "10",
      },
    ],
    description: "Elevate your gaming experience with our High-Speed Gaming Mouse. Precision tracking, customizable buttons, and ergonomic design provide the competitive edge you need. Dominate the virtual battlefield with style and performance.",
    price: 1299,
    image: "/BOSHOP images/item-img-1-3.jpg",
    multipleimages: [
      "/BOSHOP images/item-img-1-5-1.jpg",
      "/images/box7_image.jpg",
      "/images/box4_image.jpg",
      "/BOSHOP images/item-img-1-5.jpg",
    ],
  },
];


export const slidesData = [
  {
    id: "001",
    img:
      "https://cdn.shopify.com/s/files/1/0130/5041/3114/files/home1_01_9e9ee306-65ab-4e2e-9a19-c54fa8039f8a_x1024.png",
    title: "Finde Premium Products",
    cta: "SHOP NOW",
  },
  {
    id: "002",
    img:
      "https://cdn.shopify.com/s/files/1/0130/5041/3114/files/home1_02_4c388999-0b9a-4a73-9fe7-1ca465ec8140_x1024.png",
    title: "Get all the Accessories you need",
    cta: "SHOP NOW",
  },
  {
    id: "003",
    img:
      "https://hongo.b-cdn.net/wp-content/uploads/2019/11/home-page-fashion-slider-01.jpg",
    title: "Wide  range of colors",
    cta: "SHOP NOW",
  },
];
